/**
* 售后登录
*/

<template>
	<div class="login-container">

		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<div class="login-box">
			<h2>Login</h2>
			<form @submit.prevent="login">
				<div class="form-group">
					<label for="username">Username:</label>
					<input type="text" id="username" v-model="username" placeholder="Enter your username" required />
				</div>
				<div class="form-group">
					<label for="password">Password:</label>
					<input type="password" id="password" v-model="password" placeholder="Enter your password"
						required />
				</div>
				<button type="submit" click="login()">Login</button>
			</form>
		</div>


	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				username: '',
				password: '',
			};
		},
		methods: {
			login() {
				this.loadingData = true;

				axios.post(this.$p_url + '/afterSale/H5/login', {
						phone: this.username,
						pwd: this.password,
					}, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("登录的返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							Cookies.set("token", response.data.data.token, {
								expires: 1
							});
							console.log("缓存的token：", Cookies.get("token"))
							if (response.data.data.type == 0) {
								//跳转到售后系统
								this.$router.push({
									path: '/AfterSalesHome',
									query: {}
								});
							} else {
								//跳转到分销
								this.$router.push({ //跳转到首页
									path: '/AfterSalesAddHome',
									query: {}
								});
							}
						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						console.error('Error fetching data:', error);
					});
			},
		},
	};
</script>

<style scoped>
	.login-container {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
		background-color: #f2f2f2;
	}

	.login-box {
		background-color: #fff;
		padding: 20px;
		border-radius: 8px;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	}

	h2 {
		text-align: center;
		color: #333;
	}

	form {
		display: flex;
		flex-direction: column;
	}

	.form-group {
		margin-bottom: 15px;
	}

	label {
		font-weight: bold;
		margin-bottom: 5px;
		color: #555;
	}

	/* 在<style scoped>中添加以下样式 */
	input {
		padding: 10px;
		border: 1px solid #ccc;
		border-radius: 4px;
		width: calc(100% - 20px);
		/* 通过减去 padding 的大小来避免重叠 */
		margin-bottom: 10px;
		/* 添加底部间距，避免与下一个元素重叠 */
	}


	button {
		padding: 10px;
		background-color: #4caf50;
		color: #fff;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		transition: background-color 0.3s;
	}

	button:hover {
		background-color: #45a049;
	}
</style>